<template>
    <row class="annotate-editor">
        <col3>
            <gravatar v-if="avatarProperties" :selected_properties="avatarProperties"></gravatar>
        </col3>
        <col9>
            <span data-testid="annotate-editor-name">{{ displayName }}</span><br>
            <span data-testid="annotate-editor-time">{{ mutation.mutated_at }}</span>
        </col9>
    </row>
</template>

<script>
  import Row from "@/components/layout/Row";
  import Col3 from "@/components/layout/Col3";
  import Col9 from "@/components/layout/Col9";
  import Gravatar from "@/components/users/Gravatar";
  import LoadUsersMixin from "@/mixins/LoadUsersMixin";
  import { editorDisplayName } from "@/utils/assetEditors";
  export default {
    components: {Gravatar, Col9, Col3, Row},
    mixins: [LoadUsersMixin],
    props: {
      'mutation': {required: true}
    },
    computed: {
      user () {
        if (this.mutation && this.mutation.user && this.mutation.user.id) {
          return this.mutation.user;
        }
        const rawId = this.mutation && this.mutation.user_id;
        const id = Number(rawId);
        if (!id) {
          return null;
        }
        const fromStore = this.$store.getters['user/get_item_by_id'](id)
          || this.$store.getters['user/get_item_by_id'](String(id));
        return fromStore || null;
      },
      displayName () {
        return editorDisplayName(this.user, this.$t('annotate.unknown_editor'));
      },
      avatarProperties () {
        return this.user && this.user.avatar_properties ? this.user.avatar_properties : null;
      }
    },
    name: "Mutation"
  }
</script>

<style scoped>

</style>
